import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: content-box;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    overflow-x: hidden;
    background: ${({ theme }) => theme.base.black};

    #ccm_notification {
      z-index: 9999999999 !important;
    }
  }

  a {
    text-decoration: none;
  }

`;

const Section = styled.section`
  background: ${({ pageWithBackgroundColor, theme }) =>
    pageWithBackgroundColor ? theme.base.white : theme.tertiary.light};
  min-height: 100vh;

  @media only screen and (max-width: 1023px) {
    max-width: 100vw;
    overflow-x: hidden;
  }
`;

export default Section;
